import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/exhibition/service-orders')({
  staticData: { crumb: { parents: [{ label: 'Exhibition' }], label: 'Service orders' } },
})
